// Curated warm / golden-hour / Indian heritage imagery
export const IMAGES = {
  // Warm golden-hour Sal / mango canopy at sunrise
  hero: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=2400&q=80",

  // Real mango orchard scene, golden light through leaves
  orchard: "https://images.pexels.com/photos/11760088/pexels-photo-11760088.jpeg?auto=compress&w=1800",

  // Sunlit forest with god-rays (Sal-like)
  sal_forest: "https://images.unsplash.com/photo-1441829266145-6d4bfb7a3ecb?auto=format&fit=crop&w=1800&q=80",

  // Vintage WWII willys jeep — warm patina
  ww2_jeep: "https://images.pexels.com/photos/33914644/pexels-photo-33914644.jpeg?auto=compress&w=1800",

  // Warm interior with fireplace glow — heritage hunting lodge
  lodge_fireplace: "https://images.pexels.com/photos/18545165/pexels-photo-18545165.jpeg?auto=compress&w=1800",

  // Rich saffron/tandoor cuisine
  tandoor: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?auto=format&fit=crop&w=1600&q=80",

  // Warm-lit vintage billiards / snooker room
  billiards: "https://images.unsplash.com/photo-1721838449374-722202a68197?auto=format&fit=crop&w=1800&q=80",

  // Warm luxury heritage bedroom
  bedroom: "https://images.unsplash.com/photo-1618773928121-c32242e63f39?auto=format&fit=crop&w=1800&q=80",

  // Antique library / warm books with brass lamp
  library: "https://images.unsplash.com/photo-1507842217343-583bb7270b66?auto=format&fit=crop&w=1800&q=80",

  // ATV / all-terrain — warm dust light
  atv: "https://images.unsplash.com/photo-1533105079780-92b9be482077?auto=format&fit=crop&w=1600&q=80",

  // Bicycle in warm sunlight
  bicycle: "https://images.unsplash.com/photo-1485965120184-e220f721d03e?auto=format&fit=crop&w=1600&q=80",

  // Golden-lit dining table
  dining_table: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1800&q=80",

  // Fresh farm produce basket — warm colors
  garden_produce: "https://images.unsplash.com/photo-1610348725531-843dff563e2c?auto=format&fit=crop&w=1600&q=80",

  // Buddhist stupa / temple architecture at golden hour
  buddhist_arch: "https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=1800&q=80",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/heritage", label: "Heritage" },
  { to: "/accommodation", label: "Stay" },
  { to: "/dining", label: "Dining" },
  { to: "/activities", label: "Experiences" },
  { to: "/club-tikratoli", label: "Club" },
  { to: "/orchard", label: "Orchard" },
  { to: "/banquet", label: "Banquets" },
  { to: "/gallery", label: "Gallery" },
  { to: "/roots", label: "Roots" },
  { to: "/contact", label: "Contact" },
];

export const ROOM_TYPES = [
  { id: "heritage-suite", name: "Deluxe", price_inr: 4499, price: "₹ 4,499 + GST", sleeps: 2, inventory: 4, desc: "Comfortable queen bed. Sleeps 2 adults." },
  { id: "buddhist-block", name: "Executive", price_inr: 4999, price: "₹ 4,999 + GST", sleeps: 2, inventory: 4, desc: "Cozy king bed. Sleeps 2 adults." },
  { id: "orchard-cottage", name: "Premium Suite", price_inr: 5999, price: "₹ 5,999 + GST", sleeps: 4, inventory: 4, desc: "Family suite with 2 king beds. Sleeps 4 adults." },
];

// Add-on meal plans — rates are per couple per night
export const MEAL_PLANS = [
  {
    id: "AP",
    short: "AP",
    name: "American Plan",
    includes: "Breakfast + Lunch + Dinner",
    rate_per_couple_per_night: 1500,
  },
  {
    id: "MAP",
    short: "MAP",
    name: "Modified American Plan",
    includes: "Breakfast + Any One Major Meal",
    rate_per_couple_per_night: 1000,
  },
];

// Perks guests get for booking directly on tikratoli.com (shown as reception discounts
// — the booking ID is the proof at check-in).
export const DIRECT_BOOKING_PERKS = [
  { amount: "20% Off", label: "Food & Beverages" },
  { amount: "10% Off", label: "Jeep Rides" },
  { amount: "20% Off", label: "Indoor Games" },
];
